export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/i;
